module.exports = __webpack_public_path__ + "static/media/workshopBanner.58582963.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/workshop/workshopBanner.png
// module id = 387
// module chunks = 1 2 3